import React from "react";

// TODO ここの引数はDATEかstringか要検討
const MessageDateDivider = ({ date }: { date: string }) => {
  return (
    <div className="flex w-full items-center justify-center py-2.5">
      <div className="h-[1px] w-1/2 bg-border" />
      <span className="flex-shrink-0 rounded-full border px-4 py-0.5 text-xs text-gray">{date}</span>
      <div className="h-[1px] w-1/2 bg-border" />
    </div>
  );
};

export default MessageDateDivider;
